import './styles.scss';

export const FilterButton = ({ label, icon, onChangeFilter, isActive, id }) => {
  return (
    <button
      className={`filter-button ${isActive ? 'active' : ''}`}
      onClick={onChangeFilter}
      data-id={id}
    >
      {icon}
      <span>{label}</span>
    </button>
  );
};
